import List from "components/common/List/list";
import { NowTrendingData } from "interfaces/main";
import { useRouter } from "next/router";
import InterestStar from "./InterestStar";
import { Forward } from "components/common/Icons";
import { TYPO } from "styles/Typo";
import { useRecoilState } from "recoil";
import { searchModalState } from "states/SearchModalState";
import { routeToStockDetailPage } from "utils/routing";
import { getStockLogo } from "utils/image";
import { TrackedStockLink } from "lib/analytics/react/link";
import { KOREA } from "utils/constant/ITME_INFO";
export function highlightText(text: string, search: string) {
  if (!search) return text;
  const regex = new RegExp(`(${search})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span key={i} className="text-blue40">
        {part}
      </span>
    ) : (
      part
    )
  );
}

function ListWithInterest({
  data,
  type,
  count,
  search,
  isSearching = false,
  listClickHandler,
}: {
  data: any;
  type?: string;
  count: number;
  search?: string;
  isSearching?: boolean;
  listClickHandler?: any;
}) {
  const router = useRouter();
  const [searchModal, setSearchModal] = useRecoilState(searchModalState);

  return (
    <div className="flex flex-col gap-2 py-2">
      {search?.trim() && router.pathname !== "/detail/[ticker]" && (
        <div
          onClick={() => {
            router.push(`/search?query=${search}`);
            setTimeout(() => {
              setSearchModal((prev) => ({ ...prev, modalOpen: false }));
            }, 500);
          }}
          className="cursor-pointer w-full hover:bg-gray2"
          data-gtm-id="searchMain-typing-btn"
        >
          <div className="flex px-6 py-2 items-center gap-3 ">
            <div className="bg-gray10 rounded-full w-[40px] h-[40px] flex items-center justify-center">
              <SearchIcon />
            </div>
            <span
              className={`${TYPO.TYPO5_1_MD} text-gray80 grow`}
            >{`'${search}' 검색하기`}</span>
            <Forward fill="gray30" height={16} width={16} />
          </div>
        </div>
      )}
      <div className="search-list-container flex flex-col gap-2">
        {data.slice(0, count).map((asset: NowTrendingData, i: number) => (
          <TrackedStockLink
            href={`/detail/${asset.ITEM_CD_DL}`}
            ticker={asset.ITEM_CD_DL}
            market={asset.LOC === KOREA ? "kr" : "us"}
            cat="stock"
            fromListId="search_main"
            rank={i + 1}
            onClick={() => {
              if (type) {
                sessionStorage.setItem("highrisk-type", type);
              }
              if (listClickHandler) {
                listClickHandler();
              }
              // routeToStockDetailPage(router, asset.ITEM_CD_DL);
            }}
            key={i}
            className="cursor-pointer flex justify-between search-list-item "
            data-gtm-id={
              search ? "searchMain-typing-list" : "searchMain-default-list"
            }
          >
            <List
              className="!px-6 hover:bg-gray2"
              num={isSearching ? undefined : i + 1}
              src={getStockLogo(asset.ITEM_CD_DL)}
              item={
                router.locale === "ko"
                  ? asset.ITEM_KR_NM &&
                    highlightText(asset.ITEM_KR_NM, search as string)
                  : asset.ITEM_ENG_NM &&
                    highlightText(asset.ITEM_ENG_NM, search as string)
              }
              price={
                asset?.CVaR_LV_KR
                  ? `${
                      router.locale === "ko"
                        ? ` ${
                            asset?.CVaR_LV_KR
                          }・최대 -${asset?.EXP_CVaRNTS_95?.toLocaleString(
                            "en-us",
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }
                          )}% 전망`
                        : `Up to -${asset?.EXP_CVaRNTS_95?.toLocaleString(
                            "en-us",
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }
                          )}% forecast・${asset?.CVaR_LV}`
                    }`
                  : undefined
              }
              HR_ITEM_NM={asset.HR_ITEM_NM}
              rightIcon={() => {
                if (!isSearching)
                  return (
                    <InterestStar
                      asset={asset}
                      triggerSectionId="search_stock_results_list"
                    />
                  );
                return <></>;
              }}
            />
          </TrackedStockLink>
        ))}
      </div>
    </div>
  );
}
const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8492 16.2635C13.718 17.1032 12.317 17.6 10.8 17.6C7.04446 17.6 4 14.5555 4 10.8C4 7.04446 7.04446 4 10.8 4C14.5555 4 17.6 7.04446 17.6 10.8C17.6 12.3171 17.1032 13.7181 16.2634 14.8493L19.9154 18.5013C20.3059 18.8918 20.3059 19.525 19.9154 19.9155C19.5248 20.306 18.8917 20.306 18.5011 19.9155L14.8492 16.2635ZM15.6 10.8C15.6 13.451 13.451 15.6 10.8 15.6C8.14903 15.6 6 13.451 6 10.8C6 8.14903 8.14903 6 10.8 6C13.451 6 15.6 8.14903 15.6 10.8Z"
        fill="var(--gray30)"
      />
    </svg>
  );
};

export default ListWithInterest;
